import { createSlice } from '@reduxjs/toolkit';

export const exhibitorSlice = createSlice({
    name: 'exhibitor',
    initialState: null,
    reducers: {
        exhibitorSet: (state, action) => {
            return action.payload;
        }
    }
});

export const { exhibitorSet } = exhibitorSlice.actions;
export default exhibitorSlice.reducer;
